<template>
  <div>
    <b-row>
      <b-col>
        <SelectedAnalysesTableComponent
          v-model="analysesPreSelected"
          :items="localItems"
          :hasItemDetail="true"
          ref="choiceAnalyses"
        ></SelectedAnalysesTableComponent>
      </b-col>
      <b-col cols="1" class="d-flex justify-content-center">
        <div class="mt-5">
          <div class="m-3">
            <b-button @click="addAnalysesSelected">
              <i class="fa fa-angle-right"></i>
            </b-button>
          </div>
          <div class="m-3">
            <b-button @click="delAnalysesSelected">
              <i class="fa fa-angle-left"></i>
            </b-button>
          </div>
        </div>
      </b-col>
      <b-col>
        <SelectedAnalysesTableComponent
          v-model="analysesPreUnSelected"
          :items="value"
          :hasItemDetail="false"
          ref="selectedAnalyses"
        ></SelectedAnalysesTableComponent>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        Les prestations réalisées sous accréditation
        (<a href="https://tools.cofrac.fr/annexes/sect1/1-6933.pdf" target="_blank">Accréditation n°1-6933, portée sur www.cofrac.fr</a>)
        sont identifiées par le symbole "*"
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SelectedAnalysesTableComponent from './SelectedAnalysesTableComponent.vue'

export default {
  name: 'SelectedAnalysesComponent',
  props: {
    value: {
      type: Array
    },
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      analysesPreSelected: [],
      analysesPreUnSelected: [],
      localItems: []
    }
  },
  mounted: function () {
    const vm = this

    vm.buildLocalItems()
  },
  methods: {
    buildLocalItems () {
      const vm = this

      let iDif = 0
      for (let i = 0; i < vm.items.length; i++) {
        const copyItem = Object.assign({}, vm.items[i])
        const indexLocalItems = i - iDif

        if (!vm.localItems[indexLocalItems]) {
          vm.localItems.push(copyItem)
        } else if (vm.localItems[indexLocalItems].SER_NUM !== copyItem.SER_NUM) {
          vm.localItems.splice(indexLocalItems, 0, Object.assign({}, copyItem))
        }

        // Correction ici : si analyses n'existe pas, utiliser ID_ANALYSES
        let analysesArray = copyItem.analyses
        if (!analysesArray && copyItem.ID_ANALYSES) {
          // On crée des objets factices ANA_NUM pour l'affichage
          analysesArray = copyItem.ID_ANALYSES.map(id => ({ ANA_NUM: id }))
        }

        vm.localItems[indexLocalItems].analyses = [...analysesArray].filter((ana) => {
          return vm.value.findIndex((v) => v.ANA_NUM === ana.ANA_NUM) === -1
        })

        if (vm.localItems[indexLocalItems].analyses.length < 1) {
          vm.localItems.splice(indexLocalItems, 1)
          iDif++
        }
      }
    },
    addAnalysesSelected () {
      const vm = this

      let analysesSelected = vm.value
      for (const analyse of vm.analysesPreSelected) {
        analysesSelected.push(analyse)
      }

      vm.initFilter()

      vm.$emit('input', analysesSelected)
    },
    delAnalysesSelected () {
      const vm = this

      let analysesSelected = vm.value
      for (const analyse of vm.analysesPreUnSelected) {
        analysesSelected.splice(analysesSelected.findIndex((item) => item.ANA_NUM === analyse.ANA_NUM), 1)
      }

      vm.initFilter()

      vm.$emit('input', analysesSelected)
    },
    initFilter () {
      const vm = this

      vm.$refs.choiceAnalyses.initFilter()
      vm.$refs.selectedAnalyses.initFilter()
    }
  },
  watch: {
    value: function () {
      const vm = this

      vm.buildLocalItems()
    },
    items: function () {
      const vm = this

      vm.buildLocalItems()
    }
  },
  components: {
    SelectedAnalysesTableComponent
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SelectedAnalysesComponent.vue